<template>
	<div id="page-wrapper">
		<div class="row page-titles">
			<div class="col-md-5 align-self-center">
				<h3 class="text-themecolor">{{ $t('backout.title') }}</h3>
			</div>
			<div class="col-md-7 align-self-center">
				<ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.revenue') }}</a></li>
					<li class="breadcrumb-item active">{{ $t('nav.backout') }}</li>
				</ol>
			</div>
		</div>
		<div class="container-fluid">
			<!-- /row -->
			<div class="row">
				<div class="col-md-12 col-sm-12">
					<div class="card">
						<div class="card-header">
							<h4>{{ $t('backout.only') }}</h4>
						</div>
						<div class="card-body">
							<el-table
							    :data="data['backout']"
							    style="width: 100%;margin-bottom: 20px;"
							    row-key="offerId"
							    border
							    default-expand-all
							    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
							    :summary-method="getSummaries"
    							show-summary>
							    <el-table-column
							      prop="offerNo"
							      :label="$t('backout.offer-no')"
							      width="120">
							    </el-table-column>
							    <el-table-column
							      prop="vacancy"
							      :label="$t('backout.vacancy')"
							      width="250">
							      <template slot-scope="scope">
							        <el-link :href="'/#/offer/' + scope.row.offerId" target="_blank">{{ scope.row.vacancy }}</el-link>
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="offerredDate"
							      :label="$t('backout.offer-date')"
							      width="120">
							    </el-table-column>
							    <el-table-column
							      prop="offerValue"
							      :label="$t('backout.offer-value')">
							    </el-table-column>
							    <el-table-column
							      prop="cashin"
							      :label="$t('backout.cashin')">
							    </el-table-column>
							    <el-table-column
							      prop="cashinDate"
							      :label="$t('backout.cashin-date')">
							    </el-table-column>
							    <el-table-column
							      prop="transfer"
							      :label="$t('backout.transfer')">
							    </el-table-column>
							    <el-table-column
							      prop="transferDate"
							      :label="$t('backout.transfer-date')"
							      width="120">
							    </el-table-column>
							    <el-table-column
							      prop="balance"
							      :label="$t('backout.balance')">
							    </el-table-column>
							</el-table>
						</div>
					</div>
				</div>
				<div class="col-md-12 col-sm-12">
					<div class="card">
						<div class="card-header">
							<h4>{{ $t('backout.history') }}</h4>
						</div>
						<div class="card-body">
							<el-table
							    :data="data.history"
							    style="width: 100%;margin-bottom: 20px;"
							    row-key="offerId"
							    border
							    default-expand-all
							    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
							    >
							    <el-table-column
							      prop="offerNo"
							      :label="$t('backout.offer-no')"
							      width="120">
							    </el-table-column>
							    <el-table-column
							      prop="vacancy"
							      :label="$t('backout.vacancy')"
							      width="250">
							      <template slot-scope="scope">
							        <el-link :href="'/#/offer/' + scope.row.offerId" target="_blank">{{ scope.row.vacancy }}</el-link>
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="offerredDate"
							      :label="$t('backout.offer-date')"
							      width="120">
							    </el-table-column>
							    <el-table-column
							      prop="offerValue"
							      :label="$t('backout.offer-value')">
							    </el-table-column>
							    <el-table-column
							      prop="cashin"
							      :label="$t('backout.cashin')">
							    </el-table-column>
							    <el-table-column
							      prop="cashinDate"
							      :label="$t('backout.cashin-date')">
							    </el-table-column>
							    <el-table-column
							      prop="transfer"
							      :label="$t('backout.transfer')">
							    </el-table-column>
							    <el-table-column
							      prop="transferDate"
							      :label="$t('backout.transfer-date')"
							      width="120">
							    </el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>
<script>
// @ is an alias to /src
import { Loading } from 'element-ui'

export default {
  name: 'BackoutList',
  props: ['message'],
  data: function() {
	return {
	  data: null
	}
  },
  watch: {
  	
  },
  methods: {
    getSummaries: function(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('backout.balance')
          return
        }
        const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            if (index === 8)
              sums[index] = sums[index].toFixed(2) + ' ' + this.$t('reimbursement.unit')
            else
              sums[index] = '';
          } else {
            sums[index] = ''
          }
        })
        return sums;
    },
    loadData: function() {
      let that = this,
          userId = localStorage.getItem('token'),
          loading = Loading.service({ fullscreen: true })
	  this.$http.get(this.API3_PREFIX + 'backout?userId=' + userId).then(function (response) {
		that.data = response.data
		that.$nextTick(() => {
		  loading.close()
		})
      }).catch(function (error) {
		console.log(error)
		that.$nextTick(() => {
		  loading.close()
		})
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>